import React, {useEffect, useState} from 'react'
import './Congrats.css';
import { useParams, useNavigate } from 'react-router';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import config from "../../config";

const serverurl = config.apiUrl;
const serverConfig = { withCredentials: true };

const Congrats = () => {
  const {id} = useParams();
  const [clicked, setclicked] = useState(false);
  const navigate = useNavigate();
  const link = `${process.env.REACT_APP_URL}/s/${id}`;
  const [post, setpost] = useState({});

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const {data} = await axios.get(`${serverurl}/api/v1/myposts/${id}`, serverConfig);
        if (data.post.status === "false") {
          toast.error("This post is not released yet");
          navigate("/");
        }
        setpost(data.post);
      } catch (error) {
        toast.error(error.response.data.message);
        navigate("/");
      }
    };
    fetchPost();
  }, []);

  const handleClick = () => {
    navigator.clipboard.writeText(link);
    setclicked(true);
    setTimeout(() => setclicked(false), 2000);
  };

  return (
    <div className="congrats-page">


      <div className="congrats-centre">

        {/* STATUS */}
        <div className="congrats-status">
          <span className="congrats-status-dot" />
          <span className="congrats-status-text">Released</span>
        </div>

        {/* HEADING */}
        <h1 className="congrats-heading">You built it.</h1>
        <p className="congrats-sub">
          You wrote this before it existed. Now it's real.
        </p>

        {/* QUOTE */}
        {post.note && (
          <div className="congrats-quote">
            <span className="congrats-quote-mark">"</span>
            <p>{post.note.length > 160 ? post.note.substring(0, 160) + "…" : post.note}"</p>
          </div>
        )}

        {/* TIME */}
        {post.totalTime && (
          <div className="congrats-time-block">
            <span className="congrats-time-label">Time to build</span>
            <span className="congrats-time-value">{post.totalTime}</span>
          </div>
        )}

        {/* DIVIDER */}
        <div className="congrats-divider" />

        {/* COPY */}
        <button className={`congrats-copy-btn${clicked ? " copied" : ""}`} onClick={handleClick}>
          <i className={`bx ${clicked ? "bx-check" : "bx-link"}`} />
          {clicked ? "Link copied" : "Copy share link"}
        </button>

        {/* ACTIONS */}
        <div className="congrats-actions">
          <Link to="/dashboard/new" className="congrats-btn-primary">
            Write your next reality
          </Link>
          <Link to="/dashboard" className="congrats-btn-secondary">
            Back to dashboard
          </Link>
        </div>

      </div>
    </div>
  );
};

export default Congrats;
